<template>
  <router-view/>
</template>

<style>
/* Global styles */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html, body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
  height: 100%;
  background-color: #000;
  font-size: 16px;
}

#app {
  height: 100%;
  background-color: #000;
  color: #fff;
  overflow-x: hidden;
  position: relative;
}

/* For making sticky footers work properly */
.page-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #0a0e17;
  width: 100%;
  overflow-x: hidden;
}

.page-content {
  flex: 1;
}

/* Utility classes */
.text-center {
  text-align: center;
}

.mt-4 {
  margin-top: 1rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

/* MEXC Theme Elements */
button {
  background-color: #1347e4;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 1rem;
  padding: 0.5rem 1rem;
  touch-action: manipulation;
}

button:hover:not(:disabled) {
  background-color: #0d3ab8;
}

button:disabled {
  background-color: #303a47;
  cursor: not-allowed;
}

input, select, textarea {
  background-color: #171d28;
  border: 1px solid #303a47;
  color: #fff;
  border-radius: 4px;
  font-size: 1rem;
  padding: 0.75rem;
  width: 100%;
  transition: border-color 0.2s;
}

input:focus, select:focus, textarea:focus {
  border-color: #1347e4;
  outline: none;
}

a {
  color: #1347e4;
  text-decoration: none;
  transition: color 0.2s;
}

a:hover {
  text-decoration: underline;
  color: #0d3ab8;
}

/* Tables and scrollable containers */
.table-container {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* Responsive grid base classes */
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -0.5rem;
  margin-left: -0.5rem;
}

.col {
  flex: 1 0 0%;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

/* Responsive font sizes */
@media (max-width: 768px) {
  html, body {
    font-size: 15px;
  }
  
  h1 {
    font-size: 1.75rem;
  }
  
  h2 {
    font-size: 1.5rem;
  }
  
  h3 {
    font-size: 1.25rem;
  }
}

@media (max-width: 480px) {
  html, body {
    font-size: 14px;
  }
  
  h1 {
    font-size: 1.5rem;
  }
  
  h2 {
    font-size: 1.25rem;
  }
  
  h3 {
    font-size: 1.1rem;
  }
  
  button {
    padding: 0.5rem 0.75rem;
  }
  
  input, select, textarea {
    padding: 0.6rem;
  }
}
</style>
